import CommonLogicBase from './common-logic-base';

const CommonLogicOwnData = {};
const targetData = Object.assign(CommonLogicBase, CommonLogicOwnData);
export default targetData;